// ABOUTME: Presentation metadata for the four scanstatus buckets — colour, rule text and explainer copy.
// ABOUTME: The carriers behind each bucket come from the backend response, never from a list kept here.

import { scan_statuses } from "../../../utils/staticEnums";

// Every bucket owns a colour and every header wears it, so a column can be identified at a glance.
// `tint` is separate and only reaches the cells: tinting all four columns down their full height turned
// the table into a wall of colour, so only the two that carry a consequence keep it below the header.
export const SCAN_STATUS_META = {
    [scan_statuses.SCANNED]: {
        key: scan_statuses.SCANNED,
        palette: "green",
        tint: false,
        ruleKey: "scanstatus_scanned_rule",
        detailKey: "scanstatus_scanned_detail",
        alarming: false,
    },
    [scan_statuses.NO_SCAN]: {
        key: scan_statuses.NO_SCAN,
        palette: "red",
        tint: true,
        ruleKey: "scanstatus_no_scan_rule",
        detailKey: "scanstatus_no_scan_detail",
        alarming: true,
    },
    [scan_statuses.JUST_SHIPPED]: {
        key: scan_statuses.JUST_SHIPPED,
        palette: "neutral",
        tint: false,
        ruleKey: "scanstatus_just_shipped_rule",
        detailKey: "scanstatus_just_shipped_detail",
        alarming: false,
    },
    [scan_statuses.NO_SCAN_INFO]: {
        key: scan_statuses.NO_SCAN_INFO,
        palette: "purple",
        tint: true,
        ruleKey: "scanstatus_no_info_rule",
        detailKey: "scanstatus_no_info_detail",
        alarming: false,
    },
};

// The backend hands the bucket key back as the column name, so a column identifies itself. Anything
// else — a relation name, a country — returns null and renders exactly as it always did.
export const getScanStatusMeta = (columnName) => SCAN_STATUS_META[columnName] ?? null;

// Resolve a bucket's colour off the theme tokens so the pivot matches the rest of the app in both modes.
export const scanStatusColor = (meta, colors, theme) => {
    if (!meta) return undefined;
    // The ordinary states borrow no brand colour. The grey ramp is a background scale, so as text it
    // nearly vanished on the dark ground; the primary text colour is the one that is meant to be read.
    if (meta.palette === "neutral") {
        return colors.txt?.["primary"] ?? colors.grey[400];
    }
    return colors[meta.palette]?.[400];
};
